import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/door-access/control-hubs/gate-hub.png";
import type { Product } from "../../types";
import { controlHubs } from "../product-list-groups/controlHubs";
import {
  accessPowerMethod,
  inputTerminals,
  outputRelays,
  poePorts,
  powerRedundancy,
} from "../properties";

export const gateHub: Product = {
  id: "gateHub",
  productTitle: "Gate Hub",
  productListGroup: controlHubs,
  techspecsPath: [SiteId.TechSpecs, "/unifi/door-access/ua-sk-gate"],
  storePathParts: {
    category: "door-access-starter-kit",
    productSlug: "ua-sk-gate",
  },
  description: "gateHub.description",
  customBadges: [
    {
      variant: "lightGrey",
      value: {
        type: "translation",
        value: "commons.badge.kitIncluded",
      },
    },
  ],
  image: { src: image, width: 200, height: 160 },
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '175 x 126 x 26 mm\n(6.9 x 5 x 1")',
      },
    },
    {
      propertyId: outputRelays.id,
      value: {
        type: "translation",
        value: "gateHub.outputRelays",
      },
    },
    {
      propertyId: inputTerminals.id,
      value: {
        type: "translation",
        value: "gateHub.inputTerminals",
      },
    },
    {
      propertyId: poePorts.id,
      value: {
        type: "translation",
        value: "gateHub.poePorts",
      },
    },
    {
      propertyId: accessPowerMethod.id,
      value: {
        type: "string",
        value: "PoE++",
      },
    },
    {
      propertyId: powerRedundancy.id,
      value: { type: "boolean", value: false },
    },
  ],
};
